import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';

import { concatLatestFrom } from '@ngrx/operators';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './campaign.actions';

@Injectable()
export class CampaignEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadCampaignsOverview$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadCampaignOverview),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getCampaignsOverview(dealerSlug)).pipe(
                    map((campaign) => {
                        if ('error' in campaign) {
                            return actions.loadCampaignOverviewFailure({
                                error: 'error' in campaign ? 'campaign.error' : 'Campaign not found',
                            });
                        }
                        return actions.loadCampaignOverviewSuccess({
                            campaignsOverview: campaign,
                        });
                    }),
                    catchError((error) => of(actions.loadCampaignOverviewFailure({ error }))),
                ),
            ),
        );
    });

    loadCampaignDetail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadCampaignDetail),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([{ slug }, dealerSlug]) =>
                from(this.dealerApi.getCampaignDetail(dealerSlug, slug)).pipe(
                    map((campaign) => actions.loadCampaignDetailSuccess({ campaign })),
                    catchError((error) => of(actions.loadCampaignDetailFailure({ error }))),
                ),
            ),
        );
    });

    loadDealerCampaignDetail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerCampaignDetail),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([{ campaignSlug }, dealerSlug]) =>
                from(this.dealerApi.getDealerCampaignDetail(dealerSlug, campaignSlug)).pipe(
                    map((res) => actions.loadDealerCampaignDetailSuccess(res)),
                    catchError((error) => of(actions.loadDealerCampaignDetailFailure({ error }))),
                ),
            ),
        );
    });
}
